var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAssetTracking = function SvgAssetTracking(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.91636,
    y: 8.91636,
    width: 40.1673,
    height: 28.7128,
    rx: 2.81697,
    stroke: "currentColor",
    strokeWidth: 1.83273
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9636,
    y: 37.782,
    width: 4.07273,
    height: 5.09092,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3635,
    y: 41.8547,
    width: 15.2727,
    height: 3.05455,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.094 31.6726L43.4758 31.6726",
    stroke: "currentColor",
    strokeWidth: 1.568
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1123,
    y: 26.582,
    width: 5.09091,
    height: 5.09092,
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2395,
    y: 21.491,
    width: 5.09091,
    height: 10.1818,
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 37.3669,
    y: 14.3635,
    width: 5.09091,
    height: 17.3091,
    fill: "currentColor"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8938,
    y: 16.3999,
    width: 9.16364,
    height: 2.03637,
    rx: 1.01818,
    fill: "currentColor"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8938,
    y: 20.4727,
    width: 9.16364,
    height: 2.03637,
    rx: 1.01818,
    fill: "currentColor"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8938,
    y: 24.5457,
    width: 9.16364,
    height: 2.03637,
    rx: 1.01818,
    fill: "currentColor"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8938,
    y: 28.6182,
    width: 9.16364,
    height: 2.03637,
    rx: 1.01818,
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAssetTracking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/asset-tracking.38d72404.svg";
export { ForwardRef as ReactComponent };